import { render, staticRenderFns } from "./PaymentDocumentModal.vue?vue&type=template&id=0241f89e&lang=pug"
import script from "./PaymentDocumentModal.vue?vue&type=script&lang=js"
export * from "./PaymentDocumentModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports